import { createClerkSupabaseClientCommandCenter } from './utility'

const USER_ORG_STATUS_V1_FUNCTION = 'get-user-org-status-v1'

/**
 * Fetches the signed-in user's organization status grouped by active/suspended.
 * @param {object|null|undefined} session - Clerk session object.
 * @returns {Promise<object|null>} User org status payload or null on failure.
 */
export async function getUserOrgStatusV1(session) {
  if (!session) return null

  try {
    const client = createClerkSupabaseClientCommandCenter(session)
    const { data, error } = await client.functions.invoke(USER_ORG_STATUS_V1_FUNCTION, {
      method: 'GET',
    })

    if (error) {
      console.error('Error fetching user org status:', error.message || error)
      return null
    }

    return data
  } catch (error) {
    console.error('Exception while fetching user org status:', error)
    return null
  }
}

/**
 * Returns active organization ids intersected with Clerk memberships.
 * Order follows active_org_ids from the API response.
 * @param {{ clerkMembershipOrgIds?: string[], activeOrgIds?: string[] }} params
 * @returns {string[]} Active organization ids the user can switch to.
 */
export function resolveActiveOrganizationIds({ clerkMembershipOrgIds = [], activeOrgIds = [] }) {
  const membershipOrgIdSet = new Set(clerkMembershipOrgIds.filter(Boolean))

  return activeOrgIds.filter((orgId) => orgId && membershipOrgIdSet.has(orgId))
}

/**
 * Picks the Clerk active org from active org ids intersected with Clerk memberships.
 * Prefers the current Clerk org when it is active; otherwise the first active org id.
 * @param {{ currentOrganizationId?: string|null, clerkMembershipOrgIds?: string[], activeOrgIds?: string[] }} params
 * @returns {string|null} Resolved Clerk organization id, if any.
 */
export function resolveActiveOrganizationId({
  currentOrganizationId,
  clerkMembershipOrgIds = [],
  activeOrgIds = [],
}) {
  const resolvedActiveOrgIds = resolveActiveOrganizationIds({
    clerkMembershipOrgIds,
    activeOrgIds,
  })

  if (resolvedActiveOrgIds.length === 0) return null

  if (currentOrganizationId && resolvedActiveOrgIds.includes(currentOrganizationId)) {
    return currentOrganizationId
  }

  return resolvedActiveOrgIds[0]
}
